export default function tabs() {
  const tabs_items = document.querySelectorAll('.tabs_item');

  tabs_items.forEach(el => {
    const bnt = el.querySelector('.tabs_btn');

    bnt.addEventListener('click', () => {
      tabs_itemsRemoveActive();
      el.classList.add('active');
    })
  });

  function tabs_itemsRemoveActive() {
    tabs_items.forEach(el => {
      el.classList.remove('active');
    });
  }
}
